<template>

  <nav class="ms-auto" role="navigation">
    <ul class="navbar-nav" aria-label="lower navigation bar">
      <li class="nav-item"><base-link class="nav-link" :to="'/welcome'" data-toggle="collapse" data-target=".navbar-collapse.show">Home</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/vitalsGroup/all'" data-toggle="collapse" data-target=".navbar-collapse.show">Vitals</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/currentProviders'" data-toggle="collapse" data-target=".navbar-collapse.show">Providers</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/currentProcedures'" data-toggle="collapse" data-target=".navbar-collapse.show">Procedures</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/currentDiagnosis'" data-toggle="collapse" data-target=".navbar-collapse.show">Diagnoses</base-link ></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/currentMedications'" data-toggle="collapse" data-target=".navbar-collapse.show">Medication</base-link ></li>
      <li v-if="administrator" class="nav-item dropdown-li"><base-link class="nav-link" :to="'/currentNurse'" data-toggle="collapse" data-target=".navbar-collapse.show">Nurses</base-link >
         <ul class="dropdown-li-ul" aria-label="dropdown">
         <!--- <li class="dropdown-li-ul-li"><router-link to="/currentNurse" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Add Nurse</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/user/verifynurse" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Verify Nurses</router-link></li>-->
          <li class="dropdown-li-ul-li"><router-link to="/user/nursesettings" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Nurse Settings</router-link></li>
         </ul>
      </li>
      <li v-if="!administrator" class="nav-item dropdown-li">
        <a class="nav-link name" >Historical<font-awesome-icon icon="caret-down" /></a>
        <ul class="dropdown-li-ul" aria-label="dropdown">
          <li class="dropdown-li-ul-li"><router-link to="/providers" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Providers</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/procedureKinds" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Procedures</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/diagnosis" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Diagnoses</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/medication" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Medications</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/reports" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Reports</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/vaccination" @click.native="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Vaccinations</router-link></li>
        </ul>
      </li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/cdas'" data-toggle="collapse" data-target=".navbar-collapse.show">CDAs</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/pdfs'" data-toggle="collapse" data-target=".navbar-collapse.show">PDFs</base-link ></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/data-upload'" data-toggle="collapse" data-target=".navbar-collapse.show">Upload Data</base-link ></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/watch'" data-toggle="collapse" data-target=".navbar-collapse.show">Trend Labs</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/user/devices'" data-toggle="collapse" data-target=".navbar-collapse.show">Devices</base-link></li>
      <li v-if="administrator" class="nav-item"><base-link class="nav-link" :to="'/cptBilling'" data-toggle="collapse" data-target=".navbar-collapse.show">Billing</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/cpt'" data-toggle="collapse" data-target=".navbar-collapse.show">CPT</base-link></li>
    </ul>
  </nav>
</template>

<script>
import BaseLink from './BaseLink.vue'
import { mapGetters } from "vuex";
import {getAdministrator} from "@/data/getters";

  export default {
    name: "NavigationBarBottom",
    components: {
      'base-link': BaseLink
    },
    computed: {
      ...mapGetters('login', {
        allData: "getAllData",
      }),
      administrator: function() {
        return getAdministrator(this.allData);
      }
    },
    methods: {
      closeNavbar(){
      let navbar = document.querySelector('.navbar-collapse.show');
            if (navbar) {
                new Collapse(navbar, {
                    toggle: false,
                }).hide();
            }
    },
    }
  }
</script>

<style scoped lang="scss">

$color-hover: darken(#ffffff, 10%);

@import "../../../stylesheets/modules/dropdown";

.commBtn {
  background-color: transparent;
  border: none;
}

.navbar-nav {
  font-size: 0.95rem;

  .nav-link {
    color: #fff;
    border-bottom: 1px solid transparent;
    cursor: pointer;
    display: inline-block;

    &:hover {
      color: $color-hover;
      border-bottom: 1px solid white;
    }
  }
}

.router-link-active {
  border-bottom: 1px solid white !important;
}
  $color-hover: darken(#ffffff, 10%);

  .navbar-nav {
    font-size: 0.95rem;

    .nav-link {
      color: #fff;
      border-bottom: 1px solid transparent;
      cursor: pointer;
      display: inline-block;
      &:hover {
        color: $color-hover;
        border-bottom: 1px solid white;
      }
    }
  }

  .capitalize {
    text-transform: capitalize;
  }

  .base-link-active {
    border-bottom: 1px solid white !important;
  }

</style>
